import { render, staticRenderFns } from "./tableTotal.vue?vue&type=template&id=da415396&"
import script from "./tableTotal.vue?vue&type=script&lang=js&"
export * from "./tableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports